// Styles All
import "../styles/global.css";

// Components
import "@/components/navigation/navigation.js";
import "@/components/navigation/menu.js";
import "@/components/modal.js";
import "@/components/forms/inputs/select.js";
import "@/components/forms/inputs/multi-select.js";
import "@/components/forms/inputs/input-phone.js";
import "@/components/forms/inputs/input-file.js";
import "@/components/pagination.js";
import "@/components/alert.js";

// 📁 Utils
import "@/utils/form-send.js";

// 🚀 Dynamic Step System (Refactored with Managers)
import { dynamicStepSystem } from "./DynamicStepSystem.js";

// Make dynamicStepSystem globally accessible for external scripts
window.dynamicStepSystem = dynamicStepSystem;

// 🎯 Initialize system when DOM is ready
document.addEventListener("DOMContentLoaded", async () => {
  // The form gate uses the shared form modules, but the tour itself must not
  // load data or initialize managers until server-side access is granted.
  if (!document.querySelector("#stepper-container")) {
    return;
  }

  try {
    await dynamicStepSystem.init();
    console.log("CRA Prague Gateway Dynamic Step System ready!");
    console.log("All managers successfully initialized and integrated");
  } catch (error) {
    console.error("❌ Failed to initialize Dynamic Step System:", error);
  }
});
